import { render } from "./ForgotPasswordPage.vue?vue&type=template&id=790a5086&scoped=true&ts=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=790a5086&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790a5086"]])

export default __exports__